<template>
  <div>
    <DataTable
        ref="dataTable"
        :url="api.ACTIONS.UNRESOLVED_LEAVES"
        :titles="titles"
        :formatter="formatter"
        :fields-hidden-add="['created_at', 'updated_at']"
        :fields-hidden-main="['reject_reason','updated_at','created_at','user_id','handler_id','first_name','last_name','approved','user']"
        :fields-extra-main="fieldsExtraMain"
        :enableEdit="false"
        :disableSearch="true"
        :enable-delete="false"
        :enableAdd="false"
        :actions-extra-main="actionsExtraMain"
    />
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-container>
          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <p class="headline">Reject Reason:</p>
            <v-textarea
                :rules="requiredRules"
                v-model="reject_reason"
                placeholder="reject reason"
                style="padding: 0 10px"
                rows="2"
            ></v-textarea>
            <v-btn block color="primary" @click="submit">Submit</v-btn>

          </v-form>
        </v-container>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import DataTable from "@/components/wasilni/DataTable";

export default {
  name: "UnresolvedLeaves",
  components: {
    DataTable
  },
  data() {
    return {
      dialog: false,
      message: "",
      valid: true,
      lazy: false,
      loading: false,
      reject_reason: null,
      selected_item: null,
      requiredRules: [(v) => !!v || "الحقل مطلوب"]
    }
  },
  methods: {
    submit() {
      this.dialog = false
      this.selected_item.reject_reason = this.reject_reason;
      this.reject_reason = '';
      this.approveOrReject(this.selected_item, 0);
    },
    approveOrReject(item, answer) {
      this.axios
          .put(`leave/${item.id}/approve_or_reject`,
              {
                'approved': answer,
                'reject_reason': item.reject_reason
              }
          )
          .then(() => {
            this.$refs.dataTable.removeItemFromTable(item);
            window.getApp.$emit("SHOW_TOAST", answer ? 'Approved.' : 'Rejected.', answer ? 'green' : 'red');
          })
          .catch((err) => {
            try {
              window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
            } catch (e) {
              window.getApp.$emit("SHOW_TOAST", "حدث خطأ", "red");
            }
          })
          .finally(() => (this.loading = false));

    }
  },
  computed: {
    titles() {
      return {
        id: '#',
        name: 'Name',
        date: 'Date',
        category: 'Category',
        reason: 'Reason',
        type: 'Type',
        paid: 'Paid',
        actions: 'Approve/Reject'
      }
    },
    formatter() {
      return {
        type: (value) => value == 0 ? 'Half' : 'Full',
        paid: (value) => value == 0 ? 'No' : 'Yes',

      }
    },
    fieldsExtraMain() {
      return {
        name: (value) => value.first_name + ' ' + value.last_name,
        actions: (value) => this.actionsExtraMain()
      }
    },
    actionsExtraMain() {
      return {
        approve: {
          icon: 'check_box',
          action: (item) => {
            this.approveOrReject(item, 1)
          }
        },
        disapprove: {
          icon: 'cancel',
          action: (item) => {
            this.dialog = true;
            this.selected_item = item;
          }
        }
      }
    }

  }
};
</script>

<style scoped>
</style>
